import { render, staticRenderFns } from "./BookkeptTable.vue?vue&type=template&id=6497fa84&scoped=true&"
import script from "./BookkeptTable.vue?vue&type=script&lang=ts&"
export * from "./BookkeptTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6497fa84",
  null
  
)

export default component.exports